import create from "zustand";

export const useStore = create((set) => {
  let section = null;

  if (process.env.NODE_ENV === "development") {
    //section = 5.2;
  }

  return {
    section,
    interacted: false,
    musicPlaying: false,
    showEndFrame: false,
    fullscreen: false,
    preventCheck: false,
    watchedSections: [],
    setSection(section) {
      set({ preventCheck: true });
      set({ section });
      setTimeout(() => {
        set({ preventCheck: false });
      }, 100);
    },
    setShowEndFrame(showEndFrame) {
      set({ showEndFrame });
    },
    setMusicPlaying(musicPlaying) {
      set({ musicPlaying });
    },
    setWatchedSections(watchedSections) {
      set({ watchedSections });
    },
    setFullscreen(fullscreen) {
      set({ fullscreen });
    },
  };
});

window.addEventListener("pointerdown", () =>
  useStore.setState({ interacted: true })
);

// Save watched sections
useStore.subscribe(
  (section) => {
    const watchedSections =
      JSON.parse(window.localStorage.getItem(`kasperskey.watchedSections`)) ??
      [];
    window.localStorage.setItem(
      `kasperskey.watchedSections`,
      JSON.stringify([...watchedSections, section])
    );
  },
  (state) => state.section
);
